import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { QueryCache, useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import Grid from '@mui/material/Unstable_Grid2';
import clsx from 'clsx';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Helmet } from 'react-helmet-async';
import { useResize } from '../../hooks/resize';
import { SwCard } from '../commonComponent/SwCard';
import { MultilineTextField, SelectTextField } from '../styles/Styles';
import {
  KEY_DASHBOARD_MEMO_LIST,
  KEY_DASHBOARD_SHORTCUT_LIST,
} from '../../common/key';
import {
  deleteDashboardMemo,
  getDashboardMemoList,
  postDashboardMemoRegister,
  deleteDashboardShortcut,
  getDashboardShortcutList,
  postDashboardShortcutRegister,
} from '../../common/api/ApiDashboard';
import { SwAlert } from '../commonComponent/views/SwAlert';
import { SwSnackbar } from '../commonComponent/views/SwSnackbar';
import { IDashboardMemo, IDashboardShortcut } from '../../models/dashboard';
import { timestamp2Localestring } from '../../common/helper';
import { dashBoardState } from '../../common/atom';
import { useSession } from '../../hooks/session';
import { Users } from '../userManagement/users/Index';
import { Schools } from '../school/Index';
import { Books } from '../book/Index';
import { BookInquire } from '../book/BookInquire';
import { SchoolInquire } from '../school/SchoolInquire';

interface Props {}

const tabs = [
  {
    id: 'users/userinquire',
    title: '사용자 목록',
  },
];

export const Dashboard: React.FC<Props> = () => {
  const selectRef = useRef<any>();
  const { loginVal, session } = useSession();
  const { isMobile } = useResize();
  const navigate = useNavigate();
  const [dashBoardInfo, setDashBoardInfo] = useRecoilState(dashBoardState);

  const addBadgeCount = (count: number) => {
    const newCount = Number.isNaN(dashBoardInfo.count)
      ? count
      : dashBoardInfo.count + count;
    setDashBoardInfo({
      count: newCount,
    });
  };

  const resetBadgeCount = () => {
    setDashBoardInfo({
      count: 0,
    });
  };

  useEffect(() => {
    resetBadgeCount();
  }, []);

  return (
    <Box className={clsx({ root: !isMobile() }, { root_resize: isMobile() })}>
      {loginVal.value.user.roleName === '일반' ? (
        <SchoolInquire />
      ) : loginVal.value.user.roleName === '관리자1' ? (
        <SchoolInquire />
      ) : loginVal.value.user.roleName === '관리자2' ? (
        <BookInquire />
      ) : (
        <BookInquire />
      )}
    </Box>
  );
};
